<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/RM4RvW/tc-custom/9781626812284.jpg?1705552748901" alt="This image is the cover for the book Bad Guys, The Gibbons and Tozzi Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Bad Guys, The Gibbons and Tozzi Novels
      </h1>
      <p class="bookDescription body article font2">
        <b>A crime thriller starring two FBI agents up against the mob: “This series dazzles with fast, intricate plotting, terrific characters, and humor” (<i>Publishers Weekly</i>).</b><br/>  <br/> Mike Tozzi and Cuthbert Gibbons were once odd-couple partners in crimesolving. But Gibbons has gone into retirement—and Tozzi has just gone renegade.<br/>  <br/> After hot-headed Tozzi leaves a trail of bodies in his wake, Gibbons heads back to work to stop him. Instead, the two of them team up—and uncover a secret crime family headed by a convicted mobster pulling the strings from the safety of the witness protection program.<br/>  <br/> But it’s when Tozzi gets involved with the gangster’s sexy ex that the fur really starts to fly . . .<br/>  <br/> “[A] crackling thriller . . . This slick, fast-moving narrative offers interesting inside looks at the FBI and the Mafia and some delicious characters.” —<i>Publishers Weekly</i><br/>  <br/> “Grisly . . . Tense . . . Good stuff.” —<i>The Washington Post</i><br/>  <br/> “The best fictional cop duo around.” —<i>People</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Anthony Bruno
      </h2>
      
      <p class="authorDescription body article">Crime writer Anthony Bruno is the author of Seven (based on the hit film starring Brad Pitt and Morgan Freeman); The Iceman?The True Story of a Cold-Blooded Killer; and The Seekers?a Bounty Hunter?s Story with Joshua Armstrong. He?s also a regular contributor to CrimeLibrary.com. A fourth-degree black belt, he studies and teaches the martial art aikido.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Diversion Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ef9e7b8c